import { useState, useEffect } from 'react';

const COOKIE_KEY = 'cookie_consent_accepted';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-[var(--surface)] border border-[var(--border)] rounded-lg p-4 md:p-6 shadow-2xl backdrop-blur-md">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div className="flex-1">
              <h3 className="font-display text-lg font-semibold text-[var(--text-main)] mb-2">
                🍪 Polityka cookies
              </h3>
              <p className="text-sm text-[var(--text-muted)]">
                Używamy plików cookies, aby zapewnić Ci najlepsze doświadczenia na naszej stronie. 
                Klikając „Akceptuję”, wyrażasz zgodę na używanie cookies zgodnie z{' '}
                <a 
                  href="/aktualnosci/polityka-prywatnosci" 
                  target="_blank"
                  className="text-[var(--primary)] hover:underline"
                >
                  Polityką Prywatności
                </a>.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <button
                onClick={handleAccept}
                className="px-5 py-2.5 bg-[var(--primary)] text-[var(--primary-foreground)] font-medium rounded-lg hover:opacity-90 transition-opacity cursor-pointer"
              >
                Akceptuję
              </button>
              <a
                href="/aktualnosci/polityka-prywatnosci"
                target="_blank"
                className="px-5 py-2.5 border border-[var(--border)] text-[var(--text-main)] font-medium rounded-lg hover:bg-[var(--surface-highlight)] transition-colors text-center"
              >
                Dowiedz się więcej
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
